import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import injectSheet from 'react-jss'
import { withTranslation } from 'react-i18next'
import classNames from 'classnames'
import InfiniteScroll from 'react-infinite-scroller'
import MobileWrapper from '../../components/MobileWrapper'
import MobileHeader from '../../components/MobileHeader'
import MobileContent from '../../components/MobileContent'
import WhiteBox from '../../components/WhiteBox'
import paymentIcon from '../../assets/images/payment/payment.png'
import walletRecordIcon from '../../assets/images/payment/wallet-record.png'
import balanceIcon from '../../assets/images/payment/balance.png'
import {
  dateTimeFormatter,
  moneyFormatter,
  signedMoneyAmountFormatter,
} from '../../utils/formatter'
import { getUser, getWalletRecords } from '../../reducers/user'
import { FETCH_WALLET_RECORDS, fetchWalletRecords } from '../../actions/user'
import { createEndSelector } from '../../reducers/selector'

const styles = () => {
  return {
    list: {
      marginTop: '10px',
      marginLeft: '-15px',
      marginRight: '-15px',
      height: 'calc(100vh - 20vh + 20px - 10px - 70px)',
      overflowY: 'auto',
    },
    listItem: {
      paddingTop: '5px',
      paddingBottom: '5px',
      paddingLeft: '15px',
      paddingRight: '15px',
    },
    walletExpenseLabel: {
      color: 'red',
    },
    walletRedeemLabel: {
      color: 'green',
    },
    creditCardExpenseLabel: {
      color: 'skyblue',
    },
  }
}

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    walletRecords: getWalletRecords(state),
    isWalletRecordsEnd: createEndSelector([FETCH_WALLET_RECORDS])(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchWalletRecords(offset) {
      dispatch(fetchWalletRecords(offset))
    },
  }
}

@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@withTranslation()
@injectSheet(styles)
class WalletRecordPage extends Component {
  state = {
    initialLoad: true,
  }

  handlePullToRefresh = () => {
    console.log('handlePullToRefresh')
    this.props.fetchWalletRecords(0)
  }

  handleLoadMore = () => {
    const { walletRecords } = this.props
    this.props.fetchWalletRecords(walletRecords.length)
  }

  componentDidMount() {
    this.props.fetchWalletRecords()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.initialLoad) {
      this.setState({
        initialLoad: false,
      })
    }
  }

  render() {
    const {
      classes, user, walletRecords, isWalletRecordsEnd, t,
    } = this.props
    return (
      <MobileWrapper overlay={true}>
        <MobileHeader title={t('account_record')} />
        <MobileContent scrollable={false}>
          <WhiteBox
            title={`${t('spc_wallet')}$${moneyFormatter(user.wallet_balance)}`}
            description={t('my_balance')}
            image={balanceIcon}
          />
          <div className={classes.list}>
            <InfiniteScroll
              initialLoad={this.state.initialLoad}
              hasMore={!isWalletRecordsEnd}
              loader={<h4 key={0}>{t('loading')}</h4>}
              loadMore={this.handleLoadMore}
              threshold={70}
              useWindow={false}
            >
              {walletRecords.map((walletRecord) => {
                return (
                  <div className={classes.listItem} key={walletRecord.id}>
                    <WhiteBox
                      title={
                        !walletRecord.reason
                          ? walletRecord.type === 'EXPENSE'
                            ? `${t('expense')}`
                            : `${t('redeem')}`
                          : `${
                            walletRecord.type === 'EXPENSE' ? `${t('expense')}` : `${t('redeem')}`
                          } - ${walletRecord.reason}`
                      }
                      image={walletRecord.type === 'EXPENSE' ? paymentIcon : walletRecordIcon}
                      description={dateTimeFormatter(walletRecord.created_at)}
                      rightLabel={
                        <div
                          className={classNames({
                            [classes.walletExpenseLabel]:
                              walletRecord.category !== 'CREDIT_CARD' && walletRecord.amount < 0,
                            [classes.walletRedeemLabel]: walletRecord.amount > 0,
                            [classes.creditCardExpenseLabel]:
                              walletRecord.category === 'CREDIT_CARD' && walletRecord.amount < 0,
                          })}
                        >
                          {signedMoneyAmountFormatter(walletRecord.amount)}
                        </div>
                      }
                    />
                  </div>
                )
              })}
            </InfiniteScroll>
          </div>
        </MobileContent>
      </MobileWrapper>
    )
  }
}

WalletRecordPage.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    params: PropTypes.object.isRequired,
  }),
  classes: PropTypes.object,
  user: PropTypes.object,
  isWalletRecordsEnd: PropTypes.bool,
  walletRecords: PropTypes.array,
  fetchWalletRecords: PropTypes.func,
  t: PropTypes.func,
}

export default WalletRecordPage
